import { Tooltip } from '@odo/shared-ui';
import { compactName } from './assigneeSelectorHelpers';

// Above FloatingMenu (z 9000) so menu rows can show it, below toasts (z 9999).
const TOOLTIP_LAYER = '!z-[9001]';

interface AssigneeNameProps {
    fullname: string;
    isMe?: boolean;
    className?: string;
}

/** Compact name ("Sarah W.", or "Me") that ellipsizes; hovering shows the full stored name. */
export function AssigneeName({ fullname, isMe = false, className = '' }: AssigneeNameProps) {
    return (
        <Tooltip content={fullname} className={TOOLTIP_LAYER}>
            <span className={`min-w-0 truncate ${className}`}>
                {isMe ? 'Me' : compactName(fullname)}
            </span>
        </Tooltip>
    );
}
